import { api } from '../../../services/api/apiClient';
import type { Paginated, Query } from '../../../types/api';
import type { Activity, ActivityEntity } from '../types/activityTypes';

/** List endpoint, used by the smart table. Owner only. */
export const ACTIVITY_PATH = '/activity';

export const activityService = {
  list: (query?: Query) => api.get<Paginated<Activity>>(ACTIVITY_PATH, query),
};

/** Screen that shows a record from the log, or null when there is none (deleted, sign-ins). */
export function activityLink(entityType: ActivityEntity | string, id?: string, a?: Pick<Activity, 'action' | 'meta'>): string | null {
  if (a?.action === 'delete') return null;
  if (entityType === 'settings') return '/settings';
  if (entityType === 'attendance') return '/attendance';
  if (!id) return null;
  switch (entityType) {
    case 'customer':
      return `/customers/${id}`;
    case 'vendor':
      return `/vendors/${id}`;
    case 'item':
      return a?.meta?.itemType === 'service' ? `/work-rates/${id}/edit` : `/materials/${id}`;
    case 'master':
      return a?.meta?.masterType ? `/masters/${a.meta.masterType}/${id}/edit` : '/masters';
    case 'template':
      return `/templates/${id}/edit`;
    case 'quotation':
      return `/quotations/${id}`;
    case 'job':
      return `/jobs/${id}`;
    case 'invoice':
      return `/invoices/${id}`;
    case 'purchase':
      return `/purchases/${id}`;
    case 'expense':
      return `/expenses/${id}`;
    case 'payment':
      return `/transactions/${id}`;
    case 'payslip':
      return `/payroll/${id}`;
    case 'user':
      return `/team/${id}/edit`;
    default:
      return null;
  }
}
